import fetchWrapper from "../modules/fetchWrapper";
import { addElementAfter } from '../modules/forms';

if (document.querySelector('[data-cf7]')){
	(async () => {
		const cf7initiator = document.querySelector('[data-cf7]');
		const [status, result] = await fetchWrapper({
			url: `/wp-admin/admin-ajax.php?action=get_cf7_form&form=${cf7initiator.getAttribute('data-form')}`,
			method: "GET",
		});
		document.querySelector('[data-cf7]').innerHTML = result.data

		/** in case we disable cf7 scripts by wp_dequeue */
		// var recaptchaScript = document.createElement('script');
		// recaptchaScript.src = '/wp-content/plugins/contact-form-7/includes/js/index.js?ver=5.5.3';
		// document.body.appendChild(recaptchaScript);

		setTimeout(() => {
			wpcf7.init(document.querySelector('form'));

			const selectsDOM = document.querySelectorAll('.form-select select')
			selectsDOM.forEach(s => addElementAfter(s, '.icon'));

			const countrySelectDOM = document.querySelector('.js-country-select')
			const voivodeshipSelectDOM = document.querySelector('.js-voivodeship-select')
			if (countrySelectDOM && voivodeshipSelectDOM) {
				// console.log('js-country-select & js-voivodeship-select found!');
				countrySelectDOM.addEventListener('change', () => {
					// console.log(countrySelectDOM.value, voivodeshipSelectDOM)
					if (countrySelectDOM.value == "Polska") {
						voivodeshipSelectDOM.classList.remove('hidden')
						// voivodeshipSelectDOM.setAttribute("required", "");
						// voivodeshipSelectDOM.setAttribute("aria-required", "true");

						let option = voivodeshipSelectDOM.querySelector('option[value=" "]');
						option.remove();
					} else {
						// console.log('-');
						voivodeshipSelectDOM.classList.add('hidden')
						// voivodeshipSelectDOM.value = ""
						// voivodeshipSelectDOM.removeAttribute("required");
						// voivodeshipSelectDOM.removeAttribute("aria-required");

						let option = document.createElement('option');
						option.value = " ";
						option.innerText = "-";
						voivodeshipSelectDOM.appendChild(option);
						voivodeshipSelectDOM.value = " ";
					}
				})
			}

		}, 1000)
	})();
}
